import { useState, useEffect, useRef } from "react";
import './form.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { collection, addDoc, updateDoc, doc } from 'firebase/firestore';
import { db, auth } from '../../firebase/firebaseConfig';
import { useFormContext } from '../../context/FormContext'; // Importar o contexto

export default function FormEvento({ eventoExistente }) {
    const { formAberto, setFormAberto, selectedDate } = useFormContext();
    const [nome, setNome] = useState('');
    const [data, setData] = useState(selectedDate);
    const [hora, setHora] = useState('');
    const [cor, setCor] = useState('#bfdbfe');
    const [clienteId, setClienteId] = useState(''); // Para armazenar o clienteId sincronizado
    const [isSaving, setIsSaving] = useState(false);

    const userEmail = auth.currentUser.email; // Obtenha o ID do usuário do sessionStorage

    const formRef = useRef(null);

    // Função para obter o cliente selecionado
    const getClienteSelecionado = () => {
        const cliente = sessionStorage.getItem('clienteSelecionado');
        return cliente ? JSON.parse(cliente) : null;
    };

    useEffect(() => {
        const clienteSelecionado = getClienteSelecionado();

        if (clienteSelecionado && clienteSelecionado.id) {
            setClienteId(clienteSelecionado.id); // Atualiza o clienteId
        }

        if (eventoExistente) {
            setNome(eventoExistente.nome);
            setData(eventoExistente.data);
            setHora(eventoExistente.hora);
            setCor(eventoExistente.cor || '#bfdbfe');
            setClienteId(eventoExistente.clienteId || ''); // Atualiza o clienteId do evento
        }
    }, [eventoExistente]); // Dependência do eventoExistente

    // Verifica mudanças a cada segundo, mas somente atualiza se o cliente mudar
    useEffect(() => {
        const intervalId = setInterval(() => {
            const clienteSelecionado = getClienteSelecionado();
            if (clienteSelecionado?.id !== clienteId) {
                setClienteId(clienteSelecionado?.id);
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [clienteId]);

    // Função para salvar ou atualizar evento
    const handleSave = async () => {
        setIsSaving(true); // Desabilita o botão durante o salvamento

        try {
            // Se houver um evento existente, atualiza
            if (eventoExistente) {
                const eventoRef = doc(db, `usuarios/${userEmail}/eventos`, eventoExistente.id);
                await updateDoc(eventoRef, {
                    nome,
                    data,
                    hora,
                    cor,
                    clienteId: clienteId || null, // Se clienteId não for fornecido, envia null
                    userEmail // Inclui o ID do usuário no evento
                });
     
            } else {
                // Cria um novo evento
                await addDoc(collection(db, `usuarios/${userEmail}/eventos`), {
                    nome,
                    data,
                    hora,
                    cor,
                    clienteId: clienteId || null, // Se clienteId não for fornecido, envia null
                    userEmail // Inclui o ID do usuário no novo evento
                });

            }

            onClose();
        } catch (error) {
            console.error('Erro ao salvar o evento: ', clienteId);
            console.error('Erro ao salvar o evento: ', error);
        } finally {
            setIsSaving(false); // Reativa o botão após o salvamento
        }
    };

    const onClose = () => {
        setFormAberto(false); // Fecha o formulário
    };

    return (
        formAberto && (
            <div className="fundo-container-form" ref={formRef}>
                <div className="container-form">
                    <div className="form-header">
                        <p className="mb-4">{eventoExistente ? 'Editar Evento' : 'Adicionar Evento'}</p>
                        <button onClick={onClose} className="btn-close-form">
                            <FontAwesomeIcon icon={faTimes} size='2x' />
                        </button>
                    </div>
                    <div className="container-info-form">
                        <label className="input-label">Nome do evento</label>
                        <input
                            type="text"
                            id="nomeEvento"
                            name="nomeEvento"
                            placeholder="Nome do evento"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            className="input"
                        />

                        <label className="input-label">Data</label>
                        <input
                            type="date"
                            id="dataEvento"
                            name="dataEvento"
                            value={data}
                            onChange={(e) => setData(e.target.value)}
                            className="input"
                        />

                        <label className="input-label">Hora</label>
                        <input
                            type="time"
                            id="horaEvento"
                            name="horaEvento"
                            value={hora}
                            onChange={(e) => setHora(e.target.value)}
                            className="input"
                        />

                        <label className="input-label">Cor</label>
                        <input
                            type="color"
                            id="corEvento"
                            name="corEvento"
                            value={cor}
                            onChange={(e) => setCor(e.target.value)}
                            className="input"
                        />
                        {isSaving ? (
                            <button className="btn-salvar-form" disabled>
                                {eventoExistente ? 'Atualizando...' : 'Salvando...'}
                            </button>
                        ) : (
                            <button
                                className="btn-salvar-form"
                                onClick={() => {
                                    setIsSaving(true);
                                    handleSave();
                                }}>
                                {eventoExistente ? 'Atualizar' : 'Salvar'}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        )
    );
}
